if ( typeof ItemShippingNotice !== 'function' ) {

  class ItemShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.threshold = Number(this.getAttribute('data-free-shipping-items'));
      this.render(Number(this.getAttribute('data-cart-item-count')));
      this._onCartChange = this._onCartChange.bind(this);
      document.addEventListener('krown:cart:add', this._onCartChange);
      document.addEventListener('krown:cart:update', this._onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('krown:cart:add', this._onCartChange);
      document.removeEventListener('krown:cart:update', this._onCartChange);
    }

    _onCartChange() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => this.render(cart.item_count));
    }

    render(currentCount) {
      const remaining = this.threshold - currentCount;
      const progress = Math.min(currentCount / this.threshold, 1) * 100;

      let message = '';
      let isEligible = false;

      if ( remaining > 0 ) {
        message = window.KROWN.settings.locales.item_shipping_notice_remaining
          .replace('{{ remaining_count }}', remaining);
      } else {
        message = window.KROWN.settings.locales.item_shipping_notice_eligible;
        isEligible = true;
      }

      const barColor = isEligible
        ? 'var(--color-alert-success, #4caf50)'
        : 'var(--color-accent, currentColor)';

      this.innerHTML = `
        <div class="item-shipping-notice ${isEligible ? 'item-shipping-notice--eligible' : ''}">
          <p class="item-shipping-notice__text">${message}</p>
          <div class="item-shipping-notice__bar-track">
            <div class="item-shipping-notice__bar-fill" style="width:${progress}%;background:${barColor}"></div>
          </div>
        </div>`;
    }

  }

  if ( typeof customElements.get('item-shipping-notice') == 'undefined' ) {
    customElements.define('item-shipping-notice', ItemShippingNotice);
  }

}
